import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { randomString } from 'src/app/lib/random-string';
import { PermissionsPipe } from '../../../../shared-extra/pipes/permissions.pipe';
import { FormsModule } from '@angular/forms';
import { TransitionPreventorDirective } from '../../../../shared/directives/transition-preventor.directive';

@Component({
    selector: 'app-action-box-switch',
    templateUrl: './action-box-switch.component.html',
    styleUrls: ['./action-box-switch.component.scss'],
    standalone: true,
    imports: [
        TransitionPreventorDirective,
        FormsModule,
        PermissionsPipe,
    ],
})
export class ActionBoxSwitchComponent {
  id = randomString(12);
  @Input() switchValue: boolean;
  @Input() overridePermissionIfTrue: boolean;
  @Input() gallery: GalleryDto;
  @Input() permission: string;
  @Input() disabled: boolean;
  @Output() onSwitch = new EventEmitter();
}
